import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
	selector: '[appHeaderColumn]',
	standalone: true
})
export class HeaderColumn {
	@Input('appHeaderColumn') key!: string;
	constructor(public template: TemplateRef<any>) {}
}
